import * as _ from 'lodash';
import * as moment from 'moment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FieldConventionService {

  static regexIsLookup = /Id$/;

  constructor() { }

  public getDefaultLabel(fieldName: string): string {
    fieldName = _.startCase(fieldName);

    if (fieldName.endsWith(' Id')) {
      fieldName = fieldName.substr(0, fieldName.length - ' Id'.length);
    }

    return fieldName;
  }

  public isDate(value: any): value is string {
    const date = moment(value, ['DDMMYYYY', 'DDMMYY', moment.ISO_8601], true);
    return date.isValid();
  }

  public isLookupField(fieldName: string): boolean {
    return FieldConventionService.regexIsLookup.test(fieldName);
  }
}
